export const enumPermisosCerolioAdmin = Object.freeze({
  cerolioAdmin: 290,
});
